// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__7IRBm","author":"Table_author__2VIo0","authorImage":"Table_authorImage__3eSKD","unreadRow":"Table_unreadRow__1kS15"};